import { render, staticRenderFns } from "./Tandatangan.vue?vue&type=template&id=63ed731c&"
import script from "./Tandatangan.vue?vue&type=script&lang=js&"
export * from "./Tandatangan.vue?vue&type=script&lang=js&"
import style0 from "./Tandatangan.vue?vue&type=style&index=0&id=63ed731c&prod&lang=css&"
import style1 from "./Tandatangan.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports